import React, { useState, useEffect } from "react";
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

const EarningDetails = () => {
  const [earnings, setEarnings] = useState([]);
  const [totalEarnings, setTotalEarnings] = useState(0);
  const [weeklyEarnings, setWeeklyEarnings] = useState(0);
  const [monthlyEarnings, setMonthlyEarnings] = useState(0);
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
  });

  useEffect(() => {
    fetchEarnings();
  }, [filters]);

  const fetchEarnings = async () => {
    const hostData = getItemFromLocalStorage('hostProfile');
    let formData = new FormData();
    formData.append('token', hostData.host_access_token);
    formData.append('date_from', filters.dateFrom || '');
    formData.append('date_to', filters.dateTo || '');

    try {
      const response = await axios.post(
        `${params.baseURL}${params.endpoints.getEarnings}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status === 'success') {
        const data = response.data.data;

        const total = data.reduce((sum, item) => sum + parseFloat(item.total_earning || 0), 0);

        const week = data.reduce((sum, item) => {
          if (isThisWeek(item.booking_date)) {
            return sum + parseFloat(item.total_earning || 0);
          }
          return sum;
        }, 0);

        const month = data.reduce((sum, item) => {
          if (isThisMonth(item.booking_date)) {
            return sum + parseFloat(item.total_earning || 0);
          }
          return sum;
        }, 0);

        setEarnings(data);
        setTotalEarnings(total);
        setWeeklyEarnings(week);
        setMonthlyEarnings(month);
      } else {
        toast.error('Unable to fetch earnings. Try again.');
      }
    } catch (error) {
      console.error('Error fetching earnings:', error);
      toast.error('An error occurred while fetching earnings.');
    }
  };

  const handleFilterChange = (e) => {
    setFilters({
      ...filters,
      [e.target.name]: e.target.value,
    });
  };

  /*const handleSearch = () => {
    fetchEarnings();
  };*/

  const isThisWeek = (date) => {
    const today = new Date();
    const bookingDate = new Date(date);
    const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay()));
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    return bookingDate >= startOfWeek && bookingDate <= endOfWeek;
  };

  const isThisMonth = (date) => {
    const today = new Date();
    const bookingDate = new Date(date);
    return bookingDate.getMonth() === today.getMonth() && bookingDate.getFullYear() === today.getFullYear();
  };

  const calculateDaysAgo = (dateString) => {
    if (!dateString) return "-";
    const today = new Date();
    const date = new Date(dateString);
    const diffTime = Math.abs(today - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return `${diffDays} days`;
  };

  return (
    <div>
      <Helmet>
        <title>Earnings Details</title>
        <meta name="description" content="" />
      </Helmet>

      <div className="earning-section">

        <section className="earning-glass" id="earnings-table">
          <h2 className="tnstxt">Transaction History</h2>
          <div className="table-flex">
            <div className="table-row table-header">
              <div className="table-cell" style={{width:'250px'}}>
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                PROPERTY NAME
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                BOOKING ID
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                AMOUNT
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                GUEST
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                HOST
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                AFFILIATE
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                SUBSCRIPTION
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                COUPON
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                GST
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                TOTAL EARNING
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                DATE
              </div>
              <div className="table-cell">
                <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                STATUS
              </div>
            </div>

            {earnings.length > 0 ? (
              earnings.map((earning, index) => (
                <div className="table-row" key={index}>
                  <div className="table-cell" style={{width:'250px', textTransform:'uppercase'}}>
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    {earning.property_name
                      ? earning.property_name.length > 15
                        ? earning.property_name.substring(0, 12) + "..."
                        : earning.property_name
                      : "-"}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    {earning.booking_id || "-"}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.amount || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.guest_charge || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.host_charge || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.affiliate || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    {earning.subscription_active || "-"}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.coupons || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.gst || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    INR {parseFloat(earning.total_earning || 0).toFixed(2)}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    {earning.booking_date}
                  </div>
                  <div className="table-cell">
                    <img src="/assets/img/icons/common_point_icon.png" alt="pointer" className="pointer-icon tb" />
                    {earning.status || "-"}
                  </div>
                </div>
              ))
            ) : (
              <div className="table-row">
                <div className="table-cell text-center" style={{ flex: '1 0 100%' }}>
                  No earnings found.
                </div>
              </div>
            )}
          </div>
        </section>

      </div>

    </div>
  );
};

export default EarningDetails;
